import { render } from "./MainAccountsPayable.vue?vue&type=template&id=882a6686&scoped=true"
import script from "./MainAccountsPayable.vue?vue&type=script&lang=js"
export * from "./MainAccountsPayable.vue?vue&type=script&lang=js"

import "./MainAccountsPayable.vue?vue&type=style&index=0&id=882a6686&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-882a6686"]])

export default __exports__